import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6f58324e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-float-label" }
const _hoisted_2 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MultiSelect = _resolveComponent("MultiSelect")!

  return (_openBlock(), _createElementBlock("span", _hoisted_1, [
    _createVNode(_component_MultiSelect, {
      ref: "myinput",
      modelValue: _ctx.internalValue,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.internalValue) = $event)),
      class: "w-100",
      placeholder: _ctx.placeholder,
      "option-label": _ctx.optionLabel,
      "option-value": _ctx.optionValue,
      options: _ctx.options,
      filter: _ctx.filter,
      "show-clear": _ctx.showClear,
      "empty-message": _ctx.emptyMessage,
      required: _ctx.required,
      virtualScrollerOptions: _ctx.virtualScrollerOptions,
      disabled: _ctx.disabled,
      onShow: _ctx.handleFocus,
      onHide: _ctx.handleBlur
    }, null, 8, ["modelValue", "placeholder", "option-label", "option-value", "options", "filter", "show-clear", "empty-message", "required", "virtualScrollerOptions", "disabled", "onShow", "onHide"]),
    (_ctx.label)
      ? (_openBlock(), _createElementBlock("label", _hoisted_2, _toDisplayString(_ctx.label + (_ctx.required ? ' *' : '')), 1))
      : _createCommentVNode("", true)
  ]))
}